export const SET_REQUEST_STATUS = 'SET_REQUEST_STATUS';
export const APP_LIST_REQUEST = 'APP_LIST_REQUEST';
export const SET_APP_LIST = 'SET_APP_LIST';
export const SET_APP_PAGE = 'SET_APP_PAGE';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_SEARCH_STRING = 'SET_SEARCH_STRING';
export const APP_INFO_REQUEST = 'APP_INFO_REQUEST';
export const SET_APP_INFO = 'SET_APP_INFO';
export const APP_PLAYSTORE_SEARCH_REQUEST = 'APP_PLAYSTORE_SEARCH';
export const APP_REMOVE_REQUEST = 'APP_REMOVE_REQUEST';
export const APP_CREATE_REQUEST = 'APP_CREATE_REQUEST';
export const APP_INFO_UPDATE_REQUEST = 'APP_INFO_UPDATE_REQUEST';

export const APP_RESPONSE_MESSAGE = 'APP_RESPONSE_MESSAGE';
